import PropTypes from 'prop-types';
import React, { useRef } from 'react';
import { useWillUnmount } from 'rooks';
import styled from 'styled-components';
import useWorkshopSfx from '../../../hooks/useWorkshopSfx';
import {
  CloseModalButton,
  MediumBrownPanel,
  TitleText,
  HeaderText,
} from './StyledComponents';
import { ActionButton } from '../../sharedStyledComponents/Components';
import { DescriptionText } from './FormattedText';

export const EarlyExitPanel = ({ onConfirm, onCancel, children, actionScope }) => {
  const { playTap } = useWorkshopSfx();
  const clickedRef = useRef(false);
  const timeout = useRef(null);

  const onConfirmPress = (e) => {
    if (clickedRef.current) return;
    clickedRef.current = true;
    playTap(true);
    setTimeout(() => onConfirm(e), 150);
  };

  const onCloseButtonPress = (e) => {
    if (clickedRef.current) return;
    clickedRef.current = true;
    playTap(true);
    timeout.current = setTimeout(() => onCancel(e), 150);
  };

  useWillUnmount(() => {
    clearTimeout(timeout.current);
  });

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-labelledby="early-exit-panel-title"
      data-dd-action-name={actionScope}
    >
      <MediumBrownPanel />
      {onCancel && (
        <CloseModalButton
          onClick={onCloseButtonPress}
          data-dd-action-name={`${actionScope}:close`}
        />
      )}
      <TitleText id="early-exit-panel-title">EXIT</TitleText>
      {children}
      <ContinueButton
        onClick={onConfirmPress}
        data-dd-action-name={`${actionScope}:continue`}
      >
        Go to Workshop
      </ContinueButton>
    </div>
  );
};

EarlyExitPanel.propTypes = {
  children: PropTypes.any,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func,
  actionScope: PropTypes.string,
};

EarlyExitPanel.defaultProps = {
  children: null,
  onCancel: undefined,
  actionScope: 'early-exit-panel',
};

export const BaseEarlyExitModal = ({ onConfirm, onCancel, headerText, descriptionText, children, actionScope }) => (
  <EarlyExitPanel
    onConfirm={onConfirm}
    onCancel={onCancel}
    actionScope={actionScope}
  >
    <StyledContainer>
      <StyledHeaderText>{headerText}</StyledHeaderText>
      <DescriptionText>{descriptionText}</DescriptionText>
    </StyledContainer>
    {children}
  </EarlyExitPanel>
);

BaseEarlyExitModal.propTypes = {
  children: PropTypes.any,
  descriptionText: PropTypes.string.isRequired,
  headerText: PropTypes.string.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func,
  actionScope: PropTypes.string,
};

BaseEarlyExitModal.defaultProps = {
  children: null,
  onCancel: undefined,
  actionScope: 'early-exit-panel',
};

export default EarlyExitPanel;

const ContinueButton = styled(ActionButton)`
  position: absolute;
  width: 330px;
  top: 393px;
  left: 353px;
`;

const StyledContainer = styled.div`
  position: absolute;
  top: 177px;
  left: 486;
  height: 216px;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const StyledHeaderText = styled(HeaderText)`
  height: 32;
  margin: 0 0 21px;
`;
